import type { Crumb } from "../breadcrumb";
import { parsePublicPathname } from "./paths";
import { languageDestination } from "./navigation";

/** Private draft labels do not confer publication eligibility. */
const ROLE_LABELS: Record<string, string> = {
  "/careers/education-content-writer": "教育内容撰稿人",
  "/careers/h2-biology-tutor": "H2 生物导师 - A-Level",
  "/careers/h2-chemistry-tutor": "H2 化学导师 - A-Level",
  "/careers/h2-maths-tutor": "H2 数学导师 - A-Level",
  "/careers/h2-physics-tutor": "H2 物理导师 - A-Level",
  "/careers/ip-biology-tutor": "IP 生物导师",
  "/careers/ip-chemistry-tutor": "IP 化学导师招聘",
  "/careers/ip-mathematics-tutor": "IP 数学导师",
  "/careers/ip-physics-tutor": "IP 物理导师",
  "/careers/o-level-science-tutor": "O-Level 科学导师",
  "/careers/primary-science-maths-tutor": "小学科学与数学导师",
  "/careers/stem-lab-assistant": "STEM 实验室助理",
  "/careers/stem-lab-facilitator": "STEM 实验课指导员",
  "/careers/teaching-intern": "教学实习生",
};

export function mandarinCareersBreadcrumbs(pathname: string): Crumb[] {
  const parsed = parsePublicPathname(pathname);
  const path = parsed.contentPathname;
  if (
    parsed.locale !== "zh-Hans" ||
    (path !== "/careers" && !ROLE_LABELS[path])
  ) {
    throw new Error(`Missing Mandarin Careers breadcrumb: ${pathname}`);
  }
  const home = { name: "首页", href: "/zh", position: 1 };
  if (path === "/careers")
    return [home, { name: "加入我们", href: pathname, position: 2 }];
  const destination = languageDestination("/careers", "zh-Hans");
  return [
    home,
    {
      name: destination === "/careers" ? "加入我们（英文页面）" : "加入我们",
      href: destination,
      position: 2,
    },
    { name: ROLE_LABELS[path], href: pathname, position: 3 },
  ];
}
